import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

import TelemonialLogo from "../components/logo-svg.vue";

Vue.use(Vuetify);

export default new Vuetify({
  treeShake: true,
  defaultAssets: {
    font: {
      family: "Libre Baskerville",
    },
  },
  breakpoint: {
    mobileBreakpoint: "xs",
  },
  icons: {
    values: {
      logo: {
        component: TelemonialLogo,
      },
    },
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#292929",
        secondary: "#FFFFFF",
        accent: "#3A7095",
        anchor: "#3A7095", // Changes the default link color
        info: "#BBBBBB",
        background: "#D0D0D0",
      },
      dark: {
        primary: "#111111",
        secondary: "#414141",
        accent: "#3A7095",
        anchor: "#3A7095", // Changes the default link color
        info: "#888888",
        background: "#333333",
      },
    },
  },
});
